<div
  class="flex relative"
  [ngClass]="{ 'items-start h-[80vh]': presentation == 'column', 'flex-col h-full': presentation == 'row' }"
>
  <app-loader [loadingState]="loadingState$ | async" [relativeWidthAndHeight]="true"></app-loader>
  <div
    class="flex flex-row justify-center items-center p-2 gap-2 px-4 sticky top-0 min-h-24 pb-3"
    [ngClass]="{
      'md:w-1/3': presentation == 'column',
      'bg-grey-light-concrete border-b border-t border-grey-concrete': presentation == 'row',
      'z-10': (loadingState$ | async) !== 'loading',
    }"
  >
    <div class="flex flex-col w-full justify-start mb-auto">
      <div class="flex w-full items-center gap-2">
        <div
          id="search-container"
          class="flex min-w-0 flex-1 items-center justify-between border shadow bg-white border-grey-concrete border-solid cursor-text overflow-hidden my-2 ring-1 ring-white/0 focus-within:ring-primary focus-within:border-primary transition rounded-2xl"
          [formGroup]="groupSearchForm"
          [class.pointer-events-none]="(loadingState$ | async) === 'loading'"
          [class.opacity-60]="(loadingState$ | async) === 'loading'"
        >
          <input
            id="group-search-input"
            #searchInput
            class="h-min min-w-0 border-none hover:border-none bg-transparent px-4 py-1 text-lg placeholder:italic placeholder:text-base shadow-none"
            type="text"
            placeholder="Search"
            autocomplete="off"
            minlength="3"
            formControlName="groupSearchInput"
            [attr.readonly]="(loadingState$ | async) === 'loading' ? true : null"
            (keyup.enter)="selectFirstGroup()"
          />
          <ion-icon class="text-xl p-2 text-secondary" name="search-outline"> </ion-icon>
        </div>
      </div>
      @if (groupSearchForm.controls['groupSearchInput'].value.length >= 3 && (loadingState$ | async) === 'loaded') {
        <div class="flex flex-row justify-between items-center w-full mb-1">
          <div
            class="transition-all duration-300 ease-in-out flex-grow items-center"
            [ngClass]="{
              'max-h-0 opacity-0': !(
                groupSearchForm.controls['groupSearchInput'].value.length >= 3 &&
                (loadingState$ | async) === 'loaded' &&
                !isTyping &&
                (groups$ | async)?.length > 0
              ),
              'md:max-h-20 opacity-100':
                groupSearchForm.controls['groupSearchInput'].value.length >= 3 &&
                (loadingState$ | async) === 'loaded' &&
                !isTyping &&
                (groups$ | async)?.length > 0,
            }"
          >
            <div class="flex gap-2 max-sm:flex-col">
              @for (filter of unusedFilters | keyvalue; track filter.id) {
                <div>
                  <button
                    class="btn-secondary btn-xs text-xs transform transition hover:scale-105"
                    (click)="searchByFilter(filter.value.value)"
                  >
                    Search by {{ filter.value.label }}
                  </button>
                </div>
              }
            </div>
          </div>
          <span class="flex-shrink-0 ml-auto shadow-none font-normal text-sm text-grey-mid">
            {{ (paginationState$ | async)?.total_records || 'No' }}
            {{ (paginationState$ | async)?.total_records === 1 ? 'Result' : 'Results' }}
          </span>
        </div>
      }
      @if (groupSearchForm.controls['groupSearchInput'].value.length < 3 && (loadingState$ | async) !== 'loading') {
        <div class="text-center shadow-none italic font-normal text-xs text-grey-mid">
          Type 3 or more characters to search
        </div>
      }
    </div>

    @if (!showAddCustomer && showEsetParent) {
      <div class="relative mx-2 my-auto w-10 max-sm:hidden">
        <div class="absolute h-16 w-1 border-r border-grey-mid/75 left-1/2 transform -translate-x-1/2 -top-8"></div>
        <div class="absolute inset-0 flex items-center justify-center">
          <p class="text-base text-grey-blue/80 bg-grey-light-concrete leading-6 text-center pl-0.5 text-empty-field">
            or
          </p>
        </div>
      </div>
      <div>
        <button
          id="select-default-parent"
          type="button"
          class="btn-default flex shrink-0 flex-col items-center justify-center"
          [disabled]="(loadingState$ | async) === 'loading'"
          [tooltip]="'Select ' + companyName"
          (click)="selectDefaultParent()"
        >
          <app-group-display [groupId]="defaultParent" [groupName]="companyName" [enableLink]="false">
          </app-group-display>
        </button>
      </div>
    }

    @if ((permissions$ | async)?.includes('customers_upsert') && showAddCustomer) {
      <div class="relative mx-4 my-auto w-10 max-sm:hidden">
        <div class="absolute h-16 w-1 border-r border-grey-mid/75 left-1/2 transform -translate-x-1/2 -top-8"></div>
        <div class="absolute inset-0 flex items-center justify-center">
          <p class="text-base text-grey-blue/80 bg-grey-light-concrete leading-6 text-center pl-0.5 text-empty-field">
            or
          </p>
        </div>
      </div>
      <div>
        <button
          id="create-customer"
          class="btn-primary text-sm flex items-center py-2"
          (click)="addCustomer(); $event.stopPropagation()"
          tabindex="-1"
        >
          <ion-icon class="h-6 w-6 md:mr-2" name="person-add-outline"></ion-icon>
          <span class="max-sm:hidden">Create New</span>
        </button>
      </div>
    }
  </div>

  <div
    class="flex flex-col border-grey-concrete relative w-full h-full scroll-shadow overflow-auto pb-16"
    [ngClass]="{
      'border-l-2 w-2/3': presentation == 'column',
    }"
  >
    @if (
      (groups$ | async)?.length > 0 &&
      groupSearchForm.controls['groupSearchInput'].value.length >= 3 &&
      (loadingState$ | async) === 'loaded'
    ) {
      <ng-content class="group">
        @for (group of groups$ | async; track group.id) {
          <app-group-item
            class="block cursor-pointer border-b border-b-grey-concrete hover:bg-grey-concrete/40"
            [group]="group"
            (selectedGroup)="selectedGroupEvent($event)"
            [userType]="userType$ | async"
          >
          </app-group-item>
        }
      </ng-content>
    }
    @if (
      (groups$ | async)?.length == 0 &&
      groupSearchForm.controls['groupSearchInput'].value.length >= 3 &&
      (loadingState$ | async) === 'loaded' &&
      !isTyping
    ) {
      <div class="empty-state shadow-none px-10 py-32">
        <h1><ion-icon class="size-14" name="people"></ion-icon></h1>
        <h2 class="text-2xl">
          No {{ searchType }} results for '{{ groupSearchForm.controls['groupSearchInput'].value }}'
        </h2>
        <p class="text-sm">Try adjusting your search to find what you're looking for</p>
        <div
          class="transition-all duration-300 ease-in-out flex gap-1"
          [ngClass]="{
            'max-h-0 opacity-0': !(
              groupSearchForm.controls['groupSearchInput'].value.length >= 3 &&
              (loadingState$ | async) === 'loaded' &&
              !isTyping
            ),
            'md:max-h-20 opacity-100 mb-2':
              groupSearchForm.controls['groupSearchInput'].value.length >= 3 &&
              (loadingState$ | async) === 'loaded' &&
              !isTyping,
          }"
        >
          <div class="flex gap-2 justify-center items-center w-full py-4 max-sm:flex-col">
            @for (filter of unusedFilters | keyvalue; track filter.id) {
              <div class="flex items-center gap-1">
                <button
                  class="btn-secondary btn-xs text-xs transform transition hover:scale-105"
                  (click)="searchByFilter(filter.value.value)"
                >
                  Search by {{ filter.value.label }}
                </button>
              </div>
            }
            <button class="btn-xs btn-danger" (click)="clearSearch()">Clear search</button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
